var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-content',[(_vm.$config.available_payment_methods.length > 0)?_c('payments-methods'):_vm._e(),_c('table-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }